<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col cols="12">
        <v-text-field v-model="value.title" label="Title" hide-details></v-text-field>
        <v-select :items="['Event','Business']" label="Type" v-model="value.type"></v-select>
        <v-textarea :rows="3" v-model="value.description" label="Description" hide-details></v-textarea>
      </v-col>

      <v-col cols="7">
        <v-text-field v-model="value.preview.thumbnail" label="Preview Thumbnail" hide-details></v-text-field>
        <v-text-field v-model="value.preview.url" label="Preview Url" hide-details></v-text-field>
      </v-col>
      <v-col cols="5" class="text-center">
        <video-uploader v-model="value.preview"></video-uploader>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="value.price.base"
          label="Base price"
          prefix="$"
          suffix="/portal"
          hide-details
        ></v-text-field>
        <v-text-field
          v-model="value.price.video"
          label="Video price"
          prefix="$"
          suffix="/min"
          hide-details
        ></v-text-field>
        <v-text-field
          v-model="value.price.photo"
          label="Photo price"
          prefix="$"
          suffix="/photo"
          hide-details
        ></v-text-field>
        <v-text-field
          v-model="value.price.document"
          label="Document price"
          prefix="$"
          suffix="/document"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import videoUploader from "@/components/admin/video-uploader";
export default {
  name: "EditingService",
  props: ["value"],
  components: {
    videoUploader
  },
  methods: {
    onInput() {
      this.$emit("input", this.value);
    },
    onChange() {
      this.$emit("change", this.value);
    }
  }
};
</script>

<style>
</style>